import React, { useState } from "react";
import {
    Form,
    Input,
    Select,
} from 'antd';
import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

const { Option } = Select;
const prefixSelector = (
    <Form.Item name="prefix" noStyle>
        <Select style={{ width: 70 }} defaultValue="+91">
            <Option value="+91">+91</Option>
        </Select>
    </Form.Item>
);
function PhoneNumber({ onValueChanged,formRef }) {
    const [value, setValue] = useState("")
    const onChange = (value,data, event, formattedValue) => {
        console.log(value, data, event, formattedValue)
        setValue(value)
        // if (onValueChanged) {
        //     onValueChanged(value)
        // }
        const dialcode = data.dialCode;
        const rawPhone = value.slice(data.dialCode.length);
        formRef && formRef.setFields([{name:"countryCode", value: `+${dialcode}`},{name:"phone", value: rawPhone}])
        // formRef.setFieldsValue({
        //     countrycode:  `+${dialcode}`,
        //     phone: rawPhone,
        //   });
    }
    const handleOnChange = (value, data, event, formattedValue)=> {
        console.log(value, data, event, formattedValue)
       console.log({ rawPhone: value.slice(data.dialCode.length) })
      }
    return (
        <>
        <Form.Item
            name="phone_view"
            // label="Phone Number"
            rules={[{ required: true, message: 'Please input your phone number!' }]}
        >
            <PhoneInput
                country={'in'}
                value={value}
                
                onChange={(value, data, event, formattedValue)=>{onChange(value, data, event, formattedValue)}}
                // inputProps={onChange}
                
            />
            {/* <Input addonBefore={prefixSelector}  style={{ width: '100%' }} placeholder="Mobile" min={999999} max={9999999999} type='number' onChange={onChange} /> */}
        </Form.Item>
        <Form.Item visible={false} name="countryCode" style={{visibility:"hidden",height: '0px', width:"0px" }}>
            <Input visible={false} style={{ height: '0px', width:"0px" }} />
        </Form.Item>
        <Form.Item visible={false} name="phone" style={{visibility:"hidden",height: '0px', width:"0px" }}>
            <Input visible={false} style={{ height: '0px', width:"0px" }}/>
        </Form.Item>
        </>
    );
}
PhoneNumber.propTypes = {
    onValueChanged: PropTypes.func
}
export default PhoneNumber;
